<!-- PromotedAds.vue -->
<template>
    <div class="promoted-ads">
      <h2>Promowane ogłoszenia</h2>
      <div class="cars-container">
        <div class="car-tile">
          <img :src="require('@/assets/images/4007.jpg')" alt="Bmw X5">
          <div class="car-info">
              <h3>Bmw X5</h3>
              <p>CENA <span>52 000 zł</span></p>
              <p>RATY <span>866 zł/mies</span></p>
              <p>Diesel • 2012 • 220 000 km</p>
              <p>Kaczory, Wielkopolskie</p>
              <p>Ogłoszenie prywatne</p>
          </div>
      </div>
      <div class="car-tile">
          <img :src="require('@/assets/images/4007.jpg')" alt="Bmw X5">
          <div class="car-info">
              <h3>Bmw X5</h3>
              <p>CENA <span>52 000 zł</span></p>
              <p>RATY <span>866 zł/mies</span></p>
              <p>Diesel • 2012 • 220 000 km</p>
              <p>Kaczory, Wielkopolskie</p>
              <p>Ogłoszenie prywatne</p>
          </div>
      </div>
      <div class="car-tile">
          <img :src="require('@/assets/images/4007.jpg')" alt="Bmw X5">
          <div class="car-info">
              <h3>Bmw X5</h3>
              <p>CENA <span>52 000 zł</span></p>
              <p>RATY <span>866 zł/mies</span></p>
              <p>Diesel • 2012 • 220 000 km</p>
              <p>Kaczory, Wielkopolskie</p>
              <p>Ogłoszenie prywatne</p>
          </div>
      </div>
      <div class="car-tile">
          <img :src="require('@/assets/images/4007.jpg')" alt="Bmw X5">
          <div class="car-info">
              <h3>Bmw X5</h3>
              <p>CENA <span>52 000 zł</span></p>
              <p>RATY <span>866 zł/mies</span></p>
              <p>Diesel • 2012 • 220 000 km</p>
              <p>Kaczory, Wielkopolskie</p>
              <p>Ogłoszenie prywatne</p>
          </div>
      </div>
      <div class="car-tile">
          <img :src="require('@/assets/images/4007.jpg')" alt="Bmw X5">
          <div class="car-info">
              <h3>Bmw X5</h3>
              <p>CENA <span>52 000 zł</span></p>
              <p>RATY <span>866 zł/mies</span></p>
              <p>Diesel • 2012 • 220 000 km</p>
              <p>Kaczory, Wielkopolskie</p>
              <p>Ogłoszenie prywatne</p>
          </div>
      </div>
    </div>
  </div>
</template>
  
  <style scoped>
.promoted-ads {
    margin: 20px;
}

.cars-container {
  max-width: 1400px;
    margin: 20px auto;

    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start; /* Aby kafelki były wyrównane do lewej */
}

.car-tile {
    flex: 0 0 300px; /* Nie zmieniają rozmiaru, szerokość 300px */
    height: 450px; /* Stała wysokość */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid #ccc;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    margin: 10px;
    padding: 10px;
    background: #fff;
    transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease; /* Dodane przejście dla animacji */
}

.car-tile img {
    width: 100%; /* Obrazek na pełną szerokość kafelka */
    height: 300px; /* Poprawiona wysokość obrazka */
    object-fit: cover; /* Zapobiega rozciąganiu obrazka */
    transition: transform 0.3s ease; /* Dodane przejście dla animacji powiększenia obrazka */
}

.car-info h3, .car-info p {
    margin: 5px 0;
    font-size: 14px;
}

.car-info p span {
    font-weight: bold;
}

.car-tile:hover {
    background-color: #f8f8f8; /* Jasnoszare tło po najechaniu */
    transform: scale(1.03); /* Lekkie powiększenie całego kafelka */
    box-shadow: 0 4px 12px rgba(0,0,0,0.2); /* Intensywniejszy cień dla lepszego efektu */
}

.car-tile:hover img {
    transform: scale(1.1); /* Lekkie powiększenie obrazka */
}


.car-info h3, .car-info p {
    margin: 5px 0;
    font-size: 14px;
}

.car-info p span {
    font-weight: bold;
}


  </style>
  